<nav id="nav" [class.scrolled]="isScrolled()">
  <a routerLink="/" class="nav-brand">
    <img src="assets/images/logos/SLB/SLB_Blue_Logo.webp" alt="SLB" width="213" height="150" class="nav-logo-img nav-logo-light">
    <img src="assets/images/logos/SLB/SLB_White_Logo.webp" alt="SLB" width="213" height="150" class="nav-logo-img nav-logo-dark">
    <span class="nav-logo-100-wrap">
      <img src="assets/images/logos/SLB/SLB_100_Blue_Logo.webp" alt="SLB 100" width="412" height="150" class="nav-logo-img nav-logo-100-light">
      <img src="assets/images/logos/SLB/SLB_100_White_Logo.webp" alt="SLB 100" width="412" height="150" class="nav-logo-img nav-logo-100-dark">
    </span>
    <span class="nav-brand-name">Digital Marketplace</span>
  </a>

  <ul class="nav-links">
    <li><a routerLink="/" fragment="platform" [class.is-active]="activeSection() === 'platform'">Platforms</a></li>
    <li><a routerLink="/" fragment="spotlight" [class.is-active]="activeSection() === 'spotlight'">Spotlight</a></li>
    <li><a routerLink="/" fragment="domain" [class.is-active]="activeSection() === 'domain'">Domains</a></li>
    <li><a routerLink="/" fragment="features" [class.is-active]="activeSection() === 'features'">Features</a></li>
    <li><a routerLink="/catalog" routerLinkActive="is-active">Catalog</a></li>
  </ul>

  <div class="nav-actions">
    @if (searchEnabled()) {
      <button class="nav-search-btn" (click)="openSearch()" aria-label="Open search">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
          <circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>
        </svg>
      </button>
    }

    <!-- Dev settings gear (non-production only) -->
    @if (showDevSettings) {
      <div class="dev-settings-wrapper" #devWrapper>
        <button class="nav-dev-settings-btn" (click)="openDevMenu()" aria-label="Dev settings">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </button>
        <div class="dev-settings-panel" [class.open]="devMenuOpen()" [attr.aria-hidden]="!devMenuOpen()">
          <div class="login-menu-header">
            <span class="login-menu-title">Dev settings</span>
            <button class="login-menu-close" (click)="closeDevMenu()" aria-label="Close dev settings">
              <app-icon name="close"></app-icon>
            </button>
          </div>
          <div class="theme-row">
            <span class="theme-label">
              <app-icon name="sun" [size]="14"></app-icon>
              Theme
            </span>
            <select class="theme-select" [value]="themeSelectValue()" (change)="onThemeSelectChange($event)" aria-label="Select theme">
              <option value="light">Light</option>
              <option value="dark">Dark Theme #1</option>
              <option value="dark2">Dark Theme #2</option>
            </select>
          </div>
          <div class="theme-row">
            <span class="theme-label">
              <img src="assets/images/logos/SLB/tela.svg" alt="Tela" width="14" height="14" style="border-radius:3px;vertical-align:middle;">
              Tela Assistant
            </span>
            <select class="tela-visibility-select" [value]="telaVisibility()" (change)="onTelaSelectChange($event)" aria-label="Tela Assistant visibility">
              <option value="none">Off</option>
              <option value="catalog">Catalog only</option>
              <option value="all">All pages</option>
            </select>
          </div>
          <div class="theme-row">
            <span class="theme-label">
              <app-icon name="search" [size]="14"></app-icon>
              Global Search
            </span>
            <button class="theme-toggle-switch" role="switch" [attr.aria-checked]="searchEnabled() ? 'true' : 'false'" (click)="toggleSearch()">
              <span class="theme-toggle-thumb"></span>
            </button>
          </div>
          <div class="theme-row">
            <span class="theme-label">
              <app-icon name="grid-view" [size]="14"></app-icon>
              Show EA Assets
            </span>
            <button class="theme-toggle-switch" role="switch" [attr.aria-checked]="showEaProducts() ? 'true' : 'false'" (click)="toggleShowEaProducts()">
              <span class="theme-toggle-thumb"></span>
            </button>
          </div>
          <div class="theme-row">
            <span class="theme-label">
              <app-icon name="order" [size]="14"></app-icon>
              Pricing &amp; Enable workflow
            </span>
            <button class="theme-toggle-switch" role="switch" [attr.aria-checked]="pricingEnableWorkflow() ? 'true' : 'false'" (click)="togglePricingEnableWorkflow()">
              <span class="theme-toggle-thumb"></span>
            </button>
          </div>
          <div class="theme-row">
            <span class="theme-label">
              <app-icon name="close" [size]="14"></app-icon>
              Mark Product Unavailable Button
            </span>
            <button class="theme-toggle-switch" role="switch" [attr.aria-checked]="showUnavailableButton() ? 'true' : 'false'" (click)="toggleShowUnavailableButton()">
              <span class="theme-toggle-thumb"></span>
            </button>
          </div>
        </div>
      </div>
    }

    <!-- Sign in / user avatar -->
    <div class="signin-wrapper" #signinWrapper>
      @if (isSignedIn()) {
        <!-- Signed in: user pill + user menu (profile + sign out only) -->
        <button class="nav-user-avatar-btn" (click)="openUserMenu()">
          <span class="nav-user-avatar">{{ user()?.initials }}</span>
        </button>
        <div class="login-menu" [class.open]="userMenuOpen()" [attr.aria-hidden]="!userMenuOpen()">
          <div class="login-menu-header">
            <span class="login-menu-title">Profile</span>
            <button class="login-menu-close" (click)="closeUserMenu()" aria-label="Close menu">
              <app-icon name="close"></app-icon>
            </button>
          </div>
          <div class="user-menu-profile">
            <div class="user-menu-avatar-lg">{{ user()?.initials }}</div>
            <div>
              <div class="user-menu-name">{{ user()?.name }}</div>
              <div class="user-menu-email">{{ user()?.email }}</div>
            </div>
          </div>
          <app-account-selector />
          <div class="login-divider"></div>
          <app-button variant="outline" (click)="signOut()">Sign out</app-button>
        </div>
      } @else {
        <!-- Signed out: direct sign in -->
        <app-button variant="outline" (click)="signIn()">Sign in</app-button>
      }
    </div>
    <button class="nav-hamburger" [class.is-open]="mobileNavOpen()" (click)="toggleMobileNav()" aria-label="Open navigation" [attr.aria-expanded]="mobileNavOpen()">
      <span></span><span></span><span></span>
    </button>
  </div>
</nav>

<app-search-panel />
<div class="mobile-nav" [class.is-open]="mobileNavOpen()" [attr.aria-hidden]="!mobileNavOpen()">
  <ul class="mobile-nav-links">
    <li><a routerLink="/" fragment="platform" [class.is-active]="activeSection() === 'platform'" (click)="mobileNavOpen.set(false)">Platforms</a></li>
    <li><a routerLink="/" fragment="spotlight" [class.is-active]="activeSection() === 'spotlight'" (click)="mobileNavOpen.set(false)">Spotlight</a></li>
    <li><a routerLink="/" fragment="domain" [class.is-active]="activeSection() === 'domain'" (click)="mobileNavOpen.set(false)">Domains</a></li>
    <li><a routerLink="/" fragment="features" [class.is-active]="activeSection() === 'features'" (click)="mobileNavOpen.set(false)">Features</a></li>
    <li><a routerLink="/catalog" routerLinkActive="is-active" (click)="mobileNavOpen.set(false)">Catalog</a></li>
  </ul>
</div>
